<template lang="pug">
.entity-list
  .entity-list.pa-5()
    template
      v-col
        quote-steps(:value="instance", :carriers="quoteCarriers", v-bind="{ entity }")
      v-col.d-flex
        v-spacer
        g-btn.primary--text(@click="addQuote") {{$t('Shipment.addQuote')}}
      template(v-for="(item, i) in instance")
        template(v-if="isNotDeleted(item)")
          .quote
            v-row
              v-col.d-flex.align-center(cols="2")
                h2.primary--text {{$tc('Quote._name', 1)}} {{ i+1 }}
              v-col.d-flex.align-right(cols="10", style="text-align: right;")
                v-spacer
                  g-btn(icon, @click="duplicateQuote(item, i)")
                    v-icon.primary--text mdi-file-outline
                  g-btn(icon, @click="setAsDeleted(item, i)")
                    v-icon.primary--text mdi-close
            v-row
              v-col
                v-text-field(
                  :value="item.externalId",
                  :label="$t('Quote.externalId')",
                  disabled,
                )
              v-col
                v-text-field(
                  v-model="item.customerReference",
                  :label="$t('Quote.customerReference')",
                  :error-messages="errors['quote.customerReference']",
                  :error="!!errors['quote.customerReference']",
                )
              v-col
                v-autocomplete(
                  :label="$t('Quote.status')",
                  :items="quoteStatuses",
                  item-text="name",
                  item-value="id",
                  :loading="statusLoading",
                  v-model="item.statusId",
                  )
              v-col
                v-autocomplete(
                  :label="$t('Quote.rateCard')",
                  :items="quoteRateCards",
                  item-text="name",
                  item-value="name",
                  :loading="rateCardLoading",
                  v-model="item.rateCard",
                  :error-messages="errors['quote.rateCard']",
                )
            v-row
              v-col(cols="3")
                v-autocomplete(
                  :label="$t('Quote.currency')",
                  :items="currencies",
                  :item-text="currencyDisplayText",
                  item-value="code",
                  :loading="currencyLoading",
                  v-model="item.currency",
                  :error-messages="errors['quote.currency']",
                )
              v-col(cols="3")
                v-autocomplete(
                  :label="$t('Quote.carriers')",
                  :items="filterCarriers(quoteCarriers, item)",
                  item-text="name",
                  item-value="id",
                  :loading="carriersLoading",
                  v-model="item.carrierId",
                )
              v-col(cols="3")
                app-datetime-picker(
                  :value="item.createdAt",
                  :label="$t('Quote.createdAt')",
                  disabled,
                )
              v-col(cols="3")
                v-text-field(
                  :label="$t('Quote.user')",
                  :value="(item.user || {}).fullName",
                  disabled,
                )
            v-row
              v-col
                v-text-field(
                  v-model="item.routeName",
                  :label="$t('Quote.routeName')",
                )
              v-col
                v-text-field(
                  v-model="item.legName",
                  :label="$t('Quote.legName')",
                )
              v-col
                v-switch(
                  :label="$t('Quote.recommended')"
                  :input-value="item.recommended"
                  @change="validateRecommended(item, i, $event)"
                )
              v-col
                v-textarea(
                  v-model="item.reason",
                  :label="$t('Quote.reason')"
                  rows="1",
                )
            extra-field-groups(:path="`${path}[${i}]`", v-bind="{ entity }")

            quote-items(:entity="quoteItemsEntity", :relation="quoteItemsRelation", :path="path + '[' + i+ '].quoteItems'", :parent-instance="instance")
</template>

<style lang="scss" scoped>
.quote {
  .limit-column {
    max-width: 155px;
  }
}
</style>

<script>
import axios from 'axios';
import EntityMixin from '@/mixins';
import EntitesMixin from '@/mixins/entities.mixin';
import ServiceItemModal from "@/components/Quote/ServiceItemModal";
import QuoteSteps from "@/components/Shipment/QuoteSteps.vue";

export default {
  mixins: [EntityMixin, EntitesMixin],
  components: {
    ServiceItemModal,
    QuoteSteps,
  },
  props: {
    errors: {
      type: Object,
      default: () => ({}),
    },
    entity: null,
    path: null,
    parentInstance: {
      type: Object,
      default: () => { return {} }
    },
  },
  data: () => ({
    currencies: [],
    currencyLoading: true,
    quoteStatuses: [],
    statusLoading: true,
    quoteRateCards: [],
    rateCardLoading: true,
    quoteCarriers: [],
    carriersLoading: true,
  }),
  computed: {
    quoteItemsEntity() {
      return this.$findEntity('QuoteItem');
    },
    quoteItemsRelation() {
      return (this.relations || []).find(x => x.name === 'quoteItems') || {};
    },
  },
  methods: {
    validateRecommended({ legName, routeName }, i, value) {
      this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '[' + i + '].recommended', value });
      if (legName && routeName && value) {
        _.forEach(this.instance, ({ legName: lName, routeName: rName, recommended }, index) => {
          const gotRecommended = lName && rName && recommended;
          const isNotInputQuote = index != i;
          if (gotRecommended && isNotInputQuote) {
            const isSameRouteGroup = lName == legName && rName == routeName;
            if (isSameRouteGroup)
              this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '[' + index + '].recommended', value: null });
          }
        })
      }
    },
    filterCarriers(carriers, quote) {
      if (_.isEmpty(carriers) || _.isEmpty(quote)) return [];

      const legMode = _.get(quote, 'leg.transportMode');
      if (!legMode) return carriers;

      return _.filter(carriers, ['typeOfTransport', legMode]);
    },
    duplicateQuote(quote, index) {
      let copyQuote = _.cloneDeep(quote);

      //Delete unnecessary / computed data
      delete copyQuote.businessScope;
      delete copyQuote.createdAt;
      delete copyQuote.deletedAt;
      delete copyQuote.externalId;
      delete copyQuote.id;
      delete copyQuote.modifiedAt;
      delete copyQuote.uid;
      delete copyQuote.user;
      delete copyQuote.userId;

      //Handle copy of extraData
      copyQuote.extraData = !copyQuote.extraData ? [] : copyQuote.extraData.map(({ extraFieldId, type, value }) => ({ entityState: 4, extraFieldId, new: true, type, value }));

      // Change state
      copyQuote.entityState = 4;

      //Handle copy of extraData
      copyQuote.quoteItems = !copyQuote.quoteItems ? [] : copyQuote.quoteItems.map(quoteItem => {
        let copyQuoteItem = _.cloneDeep(quoteItem);

        // Delete unnecessary / computed quoteItem Data
        delete copyQuoteItem.createdAt;
        delete copyQuoteItem.deletedAt;
        delete copyQuoteItem.externalId;
        delete copyQuoteItem.id;
        delete copyQuoteItem.modifiedAt;
        delete copyQuoteItem.uid;

        // Handle copy of quoteItem extraData
        copyQuoteItem.extraData = !copyQuoteItem.extraData ? [] : copyQuoteItem.extraData.map(({ extraFieldId, type, value }) => ({ entityState: 4, extraFieldId, new: true, type, value }));

        // Change state
        copyQuoteItem.entityState = 4;
        return copyQuoteItem;
      });
      this.instance.push(copyQuote);
    },
    addQuote() {
      if (this.instance === undefined)
        this.$store.commit('SET_INSTANCE_PATH', { path: this.path, value: [] });
      this.instance.push({ entityState: 4, _Entity: 'Quote', __id: this.$uid(), quoteItems: [] });
    },
    setAsDeleted(instance, i) {
      if (instance.id) {
        this.$store.commit('SET_INSTANCE_PATH', { path: this.path + '[' + i + '].entityState', value: 2 });
      } else {
        this.instance.splice(i, 1);
      }
    },
    isNotDeleted(element) {
      return !(_.get(element, 'entityState') === 2);
    },
    async loadStatuses() {
      try {
        this.statusLoading = true;
        this.quoteStatuses = (await axios.get('Status?where[]=entity="Quote"', { params: { pageSize: -1 } })).data.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.statusLoading = false;
      }
    },
    async loadRateCards() {
      try {
        this.rateCardLoading = true;
        this.quoteRateCards = (await axios.get('RateCard', { params: { pageSize: -1 } })).data.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.rateCardLoading = false;
      }
    },
    async loadCarriers() {
      try {
        this.carriersLoading = true;
        this.quoteCarriers = (await axios.get('Carrier', { params: { pageSize: -1 } })).data.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.carriersLoading = false;
      }
    },
    async load() {
      if (this.uid) {
        try {
          const endpoint = this.$fetchLoad(`${this.entity.name}/${this.uid}`, true, ...this.loads);
          let _instance = (await axios.get(endpoint, { _Entity: this.entity.name, uid: this.uid })).data;
          this.instance = _instance;
          this.instance.entityState = 3;
          const { status } = this.instance;
          ({ blockEdit: this.blockEdit } = status || {});
        } catch (error) {
          console.error(error);
        }
      }
    },
    setQuotesEntityState() {
      if (this.instance != null) {
        for (var i = 0; i < this.instance.length; i++) {
          this.instance[i].entityState = 3;
        }
      }
    },
    sortAllQuoteItemsByUISequence() {
      if (this.instance != null) {
        for (var i = 0; i < this.instance.length; i++) {
          this.instance[i].quoteItems = this.instance[i].quoteItems.sort((a, b) => {
            if (a.uiSequence > b.uiSequence) return 1;
            if (b.uiSequence > a.uiSequence) return -1;
          });
        }
      }
    },
    async initializeCurrencies() {
      this.currencyLoading = true;
      this.currencies = await this.loadCurrencies();
      this.currencyLoading = false;
    },
  },
  async created() {
    this.loadStatuses();
    this.loadRateCards();
    this.initializeCurrencies();
    this.loadCarriers();
    this.setQuotesEntityState();
    this.sortAllQuoteItemsByUISequence();
  },
}
</script>
